import PropTypes from 'prop-types';
import React, { Component } from 'react';
import BaseElement from '../BaseElement/BaseElement';
import shallowEqual from 'fbjs/lib/shallowEqual';

export default class HtmlElement extends Component {
  shouldComponentUpdate(nextProps) {
    return !shallowEqual(this.props, nextProps);
  }

  render() {
    const {data, compProps} = this.props;

    return (
      <BaseElement {...this.props} compProps = {compProps} rootElementProps = {{dangerouslySetInnerHTML: {__html: data.rawHTML}}}/>
    );
  }
}

HtmlElement.propTypes = {
  id: PropTypes.string.isRequired,
  layout: PropTypes.shape({
    x: PropTypes.number.isRequired,
    y: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired
  }),
  data: PropTypes.shape({
    rawHTML: PropTypes.string.isRequired,
    compProps: PropTypes.object
  })
};